<template>
    <input type="file" id="inputPic" accept="image/png, image/gif, image/jpeg" @change="update($event)"
        style="display:none;" />
    <div style="width: 100%;" :id="id"></div>
</template>

<script setup>
import { watch, onMounted, onBeforeUnmount, ref, toRefs } from "vue";
import '/public/UE/ueditor.config.js';
import '/public/UE/ueditor.all.js';
import http from "@/request/request";
import { message } from 'ant-design-vue';

// ueditor加载实例
let editor = null

const props = defineProps({
    id: String,
    modelValue: String,
    uploadFunction: String,
    config: Object,
    disabled: Boolean,
})
const { modelValue, config, disabled, uploadFunction, id } = toRefs(props)
const emits = defineEmits(["update:modelValue", "valid"]);

watch(() => disabled.value, (val) => {
    setIsDisabled(val)
})
watch(
    () => modelValue.value,
    (newVal) => {
        //解决光标移动问题
        // const position = editor.getCursorPosition();
        // editor.setContent(newVal || "");
        // editor.clearSelection();
        // editor.moveCursorToPosition(position);
    }
);

onMounted(() => {
    initEditor();
});
onBeforeUnmount(() => {
    editor.destroy();
    document.getElementById(id.value).remove();
    // UE.delEditor(id.value);
});

// 实例初始化
const initEditor = () => {
    if (editor) {
        //实例销毁
        editor.destroy();
    }
    //初始化
    editor = UE.getEditor(id.value, config.value);
    editor.ready(() => {
        setIsDisabled(disabled.value)
        editor.setContent(modelValue.value || "")

        // 支持双向绑定
        editor.addListener("contentChange", () => {
            emits("update:modelValue", editor.getContent());
            !disabled.value && emits("valid");
        });
        editor.addListener("blur", () => {
            !disabled.value && emits("valid");
        });
    })
}

const addCustomButtom = () => {
    const uploadFunction = JSON.parse(widget.value.options.uploadFunction)
    if (!!uploadFunction.path) {
        UE.registerUI('button', function (editor, uiName) {
            //注册按钮执行时的command命令，使用命令默认就会带有回退操作
            editor.registerCommand(uiName, {
                execCommand: function () {
                }
            });

            //创建一个button
            var btn = new UE.ui.Button({
                //按钮的名字
                name: uiName,
                //提示
                title: '上传图片',
                //需要添加的额外样式，指定icon图标，这里默认使用一个重复的icon
                cssRules: "background-image: url('/UE/logo.png') !important;background-size: cover;",
                //点击时执行的命令
                onclick: function () {
                    //这里可以不用执行命令,做你自己的操作也可
                    editor.execCommand(uiName);
                    // 点击新图标时，触发到点击input按钮的事件
                    document.getElementById('inputPic').click()
                }
            });

            //当点到编辑内容上时，按钮要做的状态反射
            editor.addListener('selectionchange', function () {
                // var state = editor.queryCommandState(uiName);
                // if (state == -1) {
                //     btn.setDisabled(true);
                //     btn.setChecked(false);
                // } else {
                //     btn.setDisabled(false);
                //     btn.setChecked(state);
                // }
            });

            //因为你是添加button,所以需要返回这个button
            return btn;
        }
            /*index 指定添加到工具栏上的那个位置，默认时追加到最后,
            editorId 指定这个UI是那个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮*/
        );
    }
}
addCustomButtom();

const setIsDisabled = (disabled) => {
    if (!editor) return
    if (disabled) {
        editor.setDisabled();
        editor.blur();
    } else {
        editor.setEnabled();
        editor.blur();
    }
}

// 上传图片
const update = (e) => {
    const file = e.target.files[0]
    const uploadApi = JSON.parse(uploadFunction.value)

    if (!!uploadApi.path) {
        let formData = new FormData();
        if (uploadApi.params) {
            Object.keys(uploadApi.params).forEach((key) => {
                formData.append(key, uploadApi.params[key]);
            });
        }
        formData.append("files", file);
        const config = {
            url: uploadApi.path,
            data: formData,
            method: 'post',
            timeout: 60 * 1000,
            transformRequest: [function (data, headers) {
                // 去除post请求默认的Content-Type
                delete headers.post['Content-Type']
                return data
            }],
        }
        http.request(config).then(res => {
            if (res.data.code == 200) {
                const token = sessionStorage.getItem("USER_TOKEN");
                if (res.data.rows && res.data.rows.length > 0) {
                    res.data.rows.forEach(item => {
                        editor.execCommand("insertimage", {
                            src: `${item.url}?access-token=${token}`,
                            width: "100",
                            height: "100"
                        });
                        document.getElementById('inputPic').value = null;
                    });
                }
            } else if (res.data.msg) {
                document.getElementById('inputPic').value = null;
                message.error(res.msg);
            }
        }).catch(err => {
            document.getElementById('inputPic').value = null;
            message.error("上传失败," + err);
        })
    }
}
</script>